import React from "react"

import { 
    Modal, 
    Button, 
} from "react-bootstrap"

import {
    useAuthenticator,
} from "@aws-amplify/ui-react"

const EMETLUserSettings = ({ handleClose }) => {
    const {
        signOut,
    } = useAuthenticator()

    const signOutUser = () => {
        handleClose()
        signOut()
    }

    return (
        <>
            <Modal.Body>
                <Button 
                    onClick={signOutUser}
                >
                    Sign Out
                </Button>
            </Modal.Body>
            <Modal.Footer>
                <Button 
                    variant="primary" 
                    onClick={handleClose}
                >
                    Save Changes
                </Button>
            </Modal.Footer>
        </>
    )
}

export default EMETLUserSettings